import Axios from "axios"
import { makeAutoObservable } from "mobx"
import { store } from "./MainStore"
import { storeProduct } from "./StoreProduct"

class DecimalConverter {

    urlSingleConvert = 'https://member-calls2-dev.unicity.com/decimalPoints/convert'
    urlMultipleConvert = 'https://member-calls2-dev.unicity.com/decimalPoints/converts'

    constructor() {
        makeAutoObservable(this)
    }

    async singleConvert(value, unit) {
        try {
            const params = {
                unit: unit,
                number: value.toString()
            }

            const response = await Axios.get(this.urlSingleConvert, { params: params })
            return response.data
        } catch (e) {
            return e
        }
    }

    async multipleConvert(values = []) {

        try {
            if (values.length > 0) {
                const response = await Axios.post(this.urlMultipleConvert, values)
                return response.data.result
            } else {
                return []
            }
        } catch (e) {
            return e
        }
    }

    async formatPrice(value, currency) {
        if (parseInt(value) > 0) {
            const price = await this.singleConvert(value, currency || storeProduct.priceCurrency)
            return price
        } else {
            return 0
        }
    }

    async formatPv(value) {
        const price = await this.singleConvert(value, 'PV')
        return price
    }
}

export default new DecimalConverter()